import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class ReadingTask1Passage extends Vue {
  private _passage: [];
  private balaTasks: any;

  /*
  passage = [
    "Jada was excited to become a big sister. Everything was planned for the big day when her mom would have the baby. Jada would stay with their neighbours, Mr. and Mrs. Lee, while her parents were at the hospital.\n",
    "Jada liked Mr. and Mrs. Lee, who had lived in the house next door for many years. They had always been kind to her family and took care of Jada when her parents needed help.",
    "Even though Jada knew Mr. and Mrs. Lee, she was nervous. She had never spent a whole night at their house. What if she felt sick or had a bad dream?",
    "When the big day finally arrived, Jada went to Mr. and Mrs. Lee’s house and they waited to hear some news about the baby. Hours after Jada’s usual bedtime, they were still waiting. At 11 o’clock, the phone rang.",
    "“It’s a girl!” shouted Jada’s father. “She is beautiful! She looks just like you did as a baby.”",
    "“When can I see her?” asked Jada.",
    "“We will all be home tomorrow,” answered her dad. “We love you!”",
    "Jada told her dad she loved him too and said goodbye. She was warm all over.",
    "Now that she was a big sister, she felt brave.  She knew big sisters should be able to be strong when they are worried.  Before Mrs. Lee helped her into bed, Jada kissed a picture of her family goodnight. She closed her eyes and could not wait to meet her new sister."
  ];
  */

  constructor() {
    super();
    this._passage = this.$store.getters.balaPassages.readingTask1;
    this.balaTasks = this.$store.getters.balaSections;
  }

  beforeCreate() {
    this._passage = this.$store.getters.balaPassages.readingTask1;
  }

  render(h: CreateElement) {
    return (
      <Card title={this.balaTasks[1].name}>
        <div slot="mainContent">
          <v-list class="overflow-y-auto" max-height="340px">
            {this._passage.map((line, i) => (
              <v-list-item>
                <v-row>
                  <v-col cols="1">{i + 1}</v-col>
                  <v-col cols="11">
                    {this.$createElement("p", {
                      domProps: {
                        innerHTML: line
                      }
                    })}
                  </v-col>
                </v-row>
              </v-list-item>
            ))}
          </v-list>
        </div>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="secondary" to="understanding">
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = ReadingTask1Passage;
